import { Dispatch, SetStateAction, createContext, useContext } from 'react';
import { AnswerValues } from './types';

interface IDynamicFormContext {
  setSelectedOptionIds: Dispatch<SetStateAction<number[]>>;
  answerValues: AnswerValues;
  setAnswerValues: Dispatch<SetStateAction<AnswerValues>>;
  formIsReadOnly: boolean;
}

export const DynamicFormContext = createContext<
  IDynamicFormContext | undefined
>(undefined);

export const useDynamicFormContext = () => {
  const context = useContext(DynamicFormContext);
  if (context === undefined) {
    throw new Error(
      'useDynamicFormContext must be within DynamicFormContextProvider',
    );
  }
  return context;
};
